export const permissionsTenantsFull = ["tenants-full", "everything-full"];
